import React, { Component } from 'react';
import "./styles.css";
import Utils from "../../Utils";

function redondearHaciaArriba(valor: number): number {
    const decimal = valor % 1;
    return decimal >= 0.5 ? Math.ceil(valor) : Math.floor(valor);
}

export class Puntaje extends Component {

    constructor(props) {
        super(props);
        this.state = {
            proveedor: props.proveedor,
            niveles: {},
            mensage: "Cargando...",
            nivel: 0
        };
    }

    componentDidMount() {
        this.getgetNiveles();
    }

    //async getgetNiveles() {
    //    this.setState({ estado: false })
    //    await Utils.getNiveles()
    //        .then(data => {
    //            if (data !== undefined) {
    //                this.setState({ niveles: data, estado: true })
    //                let nivel = data.find(item => item.minimo <= this.state.proveedor.Total && item.maximo >= (this.state.proveedor.Total-1));
    //                this.state.nivel = nivel.numero;
    //                this.state.mensage = nivel.frase;
    //                this.graphFunction();
    //            }
    //        })
    //}

    async getgetNiveles() {
        this.setState({ estado: false });

        await Utils.getNiveles()
            .then(data => {
                if (data !== undefined) {

                    const total = this.state.proveedor.Total;

                    const nivel = data.find(
                        item =>
                            item.minimo <= total &&
                            item.maximo >= total
                    );

                    if (!nivel) {
                        console.error(
                            "No se encontr� un nivel para el Total:",
                            total
                        );
                        return;
                    }

                    this.setState(
                        {
                            niveles: data,
                            estado: true,
                            nivel: nivel.numero,
                            mensage: nivel.frase
                        },
                        () => this.graphFunction()
                    );
                }
            });
    }

    graphFunction = () => {
        const canvas = document.getElementById('grafico');
        const ctx = canvas.getContext('2d');

        let porcentaje = redondearHaciaArriba(this.state.proveedor.Total);

        let colorGrafico ="lawngreen";
        if (this.state.nivel === 1 ) colorGrafico = "red";
        if (this.state.nivel === 2) colorGrafico = "#ffd966";

        ctx.beginPath();
        ctx.arc(200, 200, 200, 0, 2 * Math.PI);
        ctx.fillStyle = '#FFF';
        ctx.fill();
        ctx.strokeStyle = '#888';
        ctx.lineWidth = 1;
        ctx.stroke();

        ctx.beginPath();
        ctx.moveTo(200, 200);
        ctx.arc(200, 200, 199.5, Math.PI * 1.5, Math.PI * 3.5);
        ctx.closePath();
        ctx.fillStyle = colorGrafico;
        ctx.fill();

        ctx.beginPath();
        ctx.arc(200, 200, 180, 0, 2 * Math.PI);
        ctx.fillStyle = '#000';
        ctx.fill();
        ctx.strokeStyle = '#555';
        ctx.lineWidth = 1;
        ctx.stroke();

        ctx.font = "95px math";
        ctx.textAlign = "center";
        ctx.fillStyle = "#FFF";
        ctx.fillText(porcentaje + "%", canvas.width / 2, 195);

        ctx.font = "60px Calibri";
        ctx.textAlign = "center";
        ctx.fillStyle = "#FFF";
        ctx.fillText("SCORE", canvas.width / 2, 273);
    }

    render() {
        return (
            <>
                <div className="cont-frase-btn">
                    <canvas id="grafico" width="400" height="400" />
                    <p style={{ marginTop: "-30px" }}>
                        {this.state.mensage}
                    </p>
                </div>
                <script>graphFunction({this.state.proveedor.Total});</script>
            </>
        );
    }
}